export default {"src":"/_next/static/media/modern-scale.dae76693.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};